import React from "react";
import { useTranslation } from "react-i18next";

const LegFilter = ({ legs, selectedLegId, setSelectedLegId }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center gap-2 justify-content-end">
      <label style={{ fontSize: "12px", whiteSpace: "nowrap" }}>{t("filterByLeg")}:</label>
      <select
        className="form-select form-select-sm"
        value={selectedLegId}
        onChange={(e) => setSelectedLegId(e.target.value)}
        style={{ maxWidth: "200px", fontSize: "12px" }}
      >
        <option value="">{t("allNetwork")}</option>
        {legs.map((leg) => (
          <option key={leg.legId} value={leg.legId}>
            {leg.username} ({t("legLabel")} {leg.legPosition})
          </option>
        ))}
      </select>
    </div>
  );
};

export default LegFilter;
